import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { OptionModel } from '../../../vss-ui.model';

@Component({
  selector: 'vss-ui-pagination',
  templateUrl: './cs-pagination.component.html',
  styleUrls: ['./cs-pagination.component.scss']
})
export class CsPaginationComponent implements OnInit, OnChanges {

  @Input() pageSize: number = 10;
  @Input() currentPage: number = 1;
  @Input() isShowSizeChanger: boolean = false;
  @Input() isShowQuickJumper: boolean = false;
  @Input() totalItem: number = 100;
  @Input() pageSizeOptions: number[] = [10, 30, 50, 100, 500];
  @Input() export: boolean = false;

  @Output() onClickBtnExcel = new EventEmitter<void>();
  @Output() onPageSizeChange = new EventEmitter<number>();
  @Output() onPageIndexChange = new EventEmitter<number>();

  startItem: number = 1;
  endItem: number = 10;
  totalPages: number = 0;
  sizeOptions: OptionModel[] = [];

  constructor() { }

  ngOnInit() {
    this.setValueTotalTemp();
    this.sizeOptions = this.pageSizeOptions.map(x => ({ value: x, label: x.toString() })) as OptionModel[];
  }

  changePageSize(value: number) {
    this.pageSize = value;
    this.setValueTotalTemp();
    this.onPageSizeChange.emit(value);
  }

  changePageIndex(value: number) {
    if (!value || value < 1) value = 1
    else if (value > this.totalPages) value = this.totalPages
    this.currentPage = value;
    this.setValueTotalTemp();
    this.onPageIndexChange.emit(value);
  }

  setValueTotalTemp() {
    this.startItem = (this.currentPage * this.pageSize) - this.pageSize + 1;
    this.endItem = this.currentPage * this.pageSize > this.totalItem ? this.totalItem : this.currentPage * this.pageSize;
    this.totalPages = Math.ceil(this.totalItem / this.pageSize);
  }

  ngOnChanges(changes: SimpleChanges): void {
  
    if (changes.totalItem?.currentValue) {
      this.setValueTotalTemp();
    }
  }

  clickExcel() {
    this.onClickBtnExcel.emit()
  }
}
